import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "./../context/AuthContext"

const AuthGuard = () => {
  const { isAuthenticated } = useAuth();

  console.log('we are inside authguard' , isAuthenticated)
  return isAuthenticated ? <Outlet /> : <Navigate to="/" replace />;
};

export default AuthGuard;